import React from 'react';
import useApiPermission from '../../hooks/useApiPermission';

/**
 * PermissionGate
 * props:
 *  - require: function | {method,url} | Array<...>
 *  - children: ReactNode | (state:{allowed:boolean,loading:boolean})=>ReactNode
 *  - hideIfDenied?: boolean (default true)
 *  - verbose?: boolean (default false)
 */
export default function PermissionGate({ require, children, hideIfDenied = true, verbose = false }) {
  const { canCall, loading } = useApiPermission();

  const requirements = Array.isArray(require) ? require : [require];
  const allowed = requirements.every((r) => (r ? canCall(r) : true));

  if (typeof children === 'function') {
    return children({ allowed, loading }) || null;
  }

  if (!allowed && hideIfDenied) {
    if (verbose) {
      try { /* eslint-disable no-console */ console.warn('[PermissionGate] denied:', requirements); } catch (_) {}
    }
    return null;
  }

  // children이 엘리먼트이고 disabled 지원 시, disabled 처리 원할 경우에는 별도 PermissionButton을 사용하세요.
  return <>{children}</>;
}

